<template>
  <div class="stock-info" :class="type">
    <div class="co-info" :class="type">
      <p class="header-gap hk-header" :class="type">公司概况</p>
      <div class="content">
        <p class="row between-xs top-xs">
          <span class="name" :class="type">公司名称</span>
          <span class="text" :class="type">{{companyInfo.company_name_zh ||companyInfo.company_name || '--'}}</span>
        </p>
        <p class="row between-xs top-xs">
          <span class="name" :class="type">上市日期</span>
          <span class="text" :class="type">{{companyInfo.listing_date || '--'}}</span>
        </p>
        <p class="row between-xs top-xs">
          <span class="name" :class="type">公司主席</span>
          <span class="text" :class="type">{{companyInfo.chairman || companyInfo.chi_director || '--'}}</span>
        </p>
        <p class="row between-xs top-xs">
          <span class="name" :class="type">所属行业</span>
          <span class="text" :class="type">{{industry || companyInfo.industry || '--'}}</span>
        </p>
        <div class="row between-xs top-xs">
          <p class="name" :class="type">公司简介</p>
          <div class="text info-text" :class="type">
            <p :class="{hide:!showInfo}">{{companyInfo.company_summary || '--'}}</p>
            <div class="row switch" v-if="companyInfo.company_summary" :class="type">
              <span v-if="!showInfo" class="open" @click="onSwitch('open')" style="line-height:12px;">展开</span>
              <span v-else class="close" @click="onSwitch('close')" :class="type" style="line-height:12px;">收起</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isHk" class="hk-content">
      <div class="main-shareholder" v-if="hkDatas.stock_holder&&hkDatas.stock_holder[0]">
        <div class="header-gap hk-header">主要股东</div>
        <div class="content">
          <p class="stock_holder" v-for="(t, index) in hkDatas.stock_holder" :key="index">{{t}}</p>
        </div>
      </div>
      <div class="history-divident" v-if="hkDatas.historical_dividends&&hkDatas.historical_dividends.length > 0">
        <!-- @click="goTo(1)" -->
        <div class="row middle-xs between-xs header-gap hk-header" >
          <p>历史分红</p>
          <!-- <img class="arrow-right" src="../../../../assets/icons/arrow-right.png" alt=""> -->
        </div>
        <div class="content-wrap">
          <div class="row title">
            <div :class="'divident-title' + index" v-for="(i, index) in dividentTitle" :key="i">
              {{i}}
            </div>
          </div>
          <div class="row middle-xs hk-data-ul" v-for="(o, index) in (!fenhongMore ? hkDatas.historical_dividends.slice(0,3): hkDatas.historical_dividends)" :key="index">
            <div class="align-l-30">{{o.ExDateTime}}</div>
            <div class="align-l-30">{{o.PayDateTime}}</div>
            <div class="align-r-40">{{o.Amount}}</div>
          </div>
          <div v-if="hkDatas.historical_dividends.length>3">
            <div v-if="!fenhongMore" class="down-btn" @click="fenhongMore = true">展开<i class="downrect-ico more"></i></div>
            <div v-else class="down-btn" @click="fenhongMore = false">收起<i class="uprect-ico more"></i></div>
          </div>
        </div>
      </div>
      <div class="history-divident" v-if="hkDatas.stock_splits&&hkDatas.stock_splits.length > 0">
        <!-- @click="goTo(2)" -->
        <div class="row middle-xs between-xs header-gap hk-header" >
          <p>拆分合并</p>
          <!-- <img class="arrow-right" src="../../../../assets/icons/arrow-right.png" alt=""> -->
        </div>
        <div class="content-wrap">
          <div class="row between-xs title">
            <div class="divident-title0">除净日</div>
            <div class="divident-title2">方案</div>
          </div>
          <div class="row between-xs middle-xs hk-data-ul" v-for="(o, index) in (!chaifenMore ? hkDatas.stock_splits.slice(0,3): hkDatas.stock_splits)" :key="index">
            <div class="align-l-30">{{o.ExDateTime}}</div>
            <div class="align-r-40">{{o.Ratio}}</div>
          </div>
          <div v-if="hkDatas.stock_splits.length>3">
            <div v-if="!chaifenMore" class="down-btn" @click="chaifenMore = true">展开<i class="downrect-ico more"></i></div>
            <div v-else class="down-btn" @click="chaifenMore = false">收起<i class="uprect-ico more"></i></div>
          </div>
        </div>
      </div>
      <div class="history-divident last-block" v-if="hkDatas.buy_back&&hkDatas.buy_back.length > 0">
        <!-- @click="goTo(3)" -->
        <div class="row middle-xs between-xs header-gap hk-header" >
          <p>回购</p>
          <!-- <img class="arrow-right" src="../../../../assets/icons/arrow-right.png" alt=""> -->
        </div>
        <div class="content-wrap">
          <div class="row between-xs title">
            <div class="divident-title0">回购日</div>
            <div class="divident-title2">回购数量</div>
          </div>
          <div class="row between-xs middle-xs hk-data-ul" v-for="(o, index) in (!huigouMore ? hkDatas.buy_back.slice(0,3): hkDatas.buy_back)" :key="index">
            <div class="align-l-30">{{o.buy_date}}</div>
            <div class="align-r-40">{{o.buy_num}}</div>
          </div>
          <div v-if="hkDatas.buy_back.length>3">
            <div v-if="!huigouMore" class="down-btn" @click="huigouMore = true">展开<i class="downrect-ico more"></i></div>
            <div v-else class="down-btn" @click="huigouMore = false">收起<i class="uprect-ico more"></i></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="us-content">
      <!-- <div class="chart" :class="type">
        <p class="header-gap" :class="type">经营业绩</p>
        <div class="row center-xs nav" :class="type">
          <div class="row tabs" style="width: 92%">
            <div class="tab" style="width: 33.3%" v-for="(tab,index) in tabs" :class="[{active:currentIndex===index}, {'border-l': currentIndex === 2 && index === 0}, {'border-r': currentIndex === 0 && index === 2}]" @click="onClickTab(index)" :key="index">
              {{tab}}
            </div>
          </div>
        </div>
        <div ref="wrap" class="wrap" @click="onClickChart" :class="type">
          <div ref="achieChart" style="width: 100%;height:100%"/>
        </div>
        <div class="items" :class="type">
          <ul class="row between-xs">
            <li v-for="(item,index) in itemsName" :class="'item-'+index" :key="index">{{item}}</li>
          </ul>
        </div>
      </div>
      <div class="chart">
        <p class="header-gap" :class="type">营收构成</p>
        <div class="row center-xs nav" :class="type">
          <div class="row tabs" style="width: 50%">
            <div class="tab" style="width: 50%" v-for="(tab,index) in revenueTabs" :class="[{active:revenuecurIdx===index}, {'border-l': revenuecurIdx === 2 && index === 0}, {'border-r': revenuecurIdx === 0 && index === 2}]" @click="onClickRevenueTab(index, tab.value)" :key="index">
              {{tab.name}}
            </div>
          </div>
        </div>
        <div class="row middle-xs revenue-wrap">
          <div ref="revenueChart" style="width: 50%;height:200px"/>
          <div class="col-xs position-legend-wrap">
            <div class="column between-xs position-legend">
              <div class="row middle-xs between-xs legend-item" v-for="(item, index) in positionLegends" :key="index">
                <div class="row middle-xs">
                  <span class="square" :style="{color: color[index]}">■</span>
                  <span class="legend-item-name">{{item.name}}</span>
                </div>
                <div class="legend-item-value">{{item.value}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chart" v-if="analysisDatas.hasOwnProperty('inst_and_insider_total')">
        <p class="header-gap" :class="type">持股分析</p>
        <div class="row middle-xs position-wrap">
          <div ref="analysisChart" style="width: 50%;height:160px"/>
          <div class="col-xs position-legend-wrap">
            <div class="column between-xs analysis-legend">
              <div class="inst_and_insider_total">{{analysisDatas.inst_and_insider_total || Number(analysisDatas.inst + analysisDatas.insider).toFixed(2)}}% TOTAL OWNERSHIP</div>
              <div class="row middle-xs between-xs legend-item" v-for="(item, index) in analysisLegends" :key="index">
                <div class="row middle-xs">
                  <span class="square" :class="'square' + index">■</span>
                  <span>{{item.name}}</span>
                </div>
                <div class="legend-item-value">{{analysisDatas[item.value]}}%</div>
              </div>
            </div>
          </div>
        </div>
        <div class="analysis-lists">
          <div class="row between-xs">
            <div>流通股本/总股本</div>
            <div v-if="analysisDatas.float_percentage">{{analysisDatas.float_percentage}}%</div>
            <div v-else>--</div>
          </div>
          <div class="row between-xs">
            <div>机构持股/流通股本</div>
            <div v-if="analysisDatas.inst_ownership_of_float">{{analysisDatas.inst_ownership_of_float}}%</div>
            <div v-else>--</div>
          </div>
          <div class="row between-xs">
            <div>ADR Ratio</div>
            <div v-if="analysisDatas.adr_ratio">{{analysisDatas.adr_ratio}}</div>
            <div v-else>--</div>
          </div>
          <div class="row between-xs">
            <div>Combined %OS</div>
            <div v-if="analysisDatas.combined_os">{{analysisDatas.combined_os}}</div>
            <div v-else>--</div>
          </div>
        </div>
      </div> -->
      <div class="top5">
        <p class="header-gap" :class="type">机构持股TOP5</p>
        <div class="content-wrap">
          <div class="row title">
            <div :class="'title' + index" v-for="(i, index) in top5Title" :key="i">
              {{i}}
            </div>
          </div>
          <div class="row middle-xs top5-content" v-for="(o, index) in institutionTop5" :key="index">
            <div class="align-l-50 top5-name">{{o.holder_name}}</div>
            <div class="align-r-20 top5-rate"><span v-if="o.os_pct || o.os_pct != 0">{{Number(o.os_pct).toFixed(3)}}%</span><span v-else>--</span></div>
            <div class="align-r-30">
              <div class="top5-chg" :class="[{rise: o.position_value > 0}, {dropped: o.position_value < 0}, {zero: o.position_value === 0}]">
                <span v-if="o.position_value == 0 || !o.position_value">未变</span>
                <span v-else>{{o.position_value | count(2, true)}}</span>
              </div>
              <div class="top5-date">{{o.report_date}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="top5">
        <p class="header-gap" :class="type">内部持股TOP5</p>
        <div class="content-wrap">
          <div class="row title">
            <div :class="'title' + index" v-for="(i, index) in top5Title" :key="i">
              {{i}}
            </div>
          </div>
          <div class="row middle-xs top5-content" v-for="(o, index) in insideTop5" :key="index">
            <div class="align-l-50 top5-name">{{o.holder_name}}</div>
            <div class="align-r-20 top5-rate">
              <span v-if="!o.os_pct || o.os_pct==0">--</span>
              <span v-else>{{Number(o.os_pct).toFixed(3)}}%</span>
            </div>
            <div class="align-r-30">
              <div class="top5-chg" :class="[{rise: o.position_value > 0}, {dropped: o.position_value < 0}, {zero: o.position_value === 0}]">
                <span v-if="!o.position_value || o.position_value == 0">未变</span>
                <span v-else>{{o.position_value | count(2, true)}}</span>
              </div>
              <div class="top5-date">{{o.report_date}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="goal-level" v-if="scoreBaseInfo.mark&&scoreBaseInfo.mark.value">
        <p class="header-gap" :class="type">目标评级</p>
        <div class="row between-xs limit-score">
          <div>1.0</div>
          <div>3.0</div>
        </div>
        <div class="line-wrap">
          <div class="column middle-xs middle-xs score-wrap" :style="[{left: scoreObj.scoreLeft + '%'}]">
            <div class="score" :style="{color: scoreObj.locationColor}">评分={{scoreObj.analysisScore}}</div>
            <div class="location-icon" :class="'location' + scoreObj.scoreIndex" :style="{left: scoreObj.locationLeft + '%'}"></div>
          </div>
          <div class="linear-line-wrap">
            <div class="linear-line" />
          </div>
        </div>
        <div class="row between-xs level-name">
          <div v-for="(item, index) in levelName" :key="index">{{item.name}}</div>
        </div>
      </div>
      <div class="goal-price" v-if="scoreBaseInfo.target_price_low != 0 && scoreBaseInfo.target_price_high != 0">
        <p class="header-gap" :class="type">目标价预测</p>
        <div class="axes-wrap">
          <div class="axes"></div>
          <div class="column low">
            <div class="dot">●</div>
            <div class="line" />
            <div class="dot-text">最低${{Number(scoreBaseInfo.target_price_low).toFixed(2)}}</div>
          </div>
          <div class="column high">
            <div class="dot">●</div>
            <div class="line" />
            <div class="dot-text">最高${{Number(scoreBaseInfo.target_price_high).toFixed(2)}}</div>
          </div>
          <div class="column average" :style="{left: averageLeft + '%'}" v-if="scoreBaseInfo.target_price > scoreBaseInfo.target_price_low && scoreBaseInfo.target_price < scoreBaseInfo.target_price_high">
            <div class="dot-text">平均${{Number(scoreBaseInfo.target_price).toFixed(2)}}</div>
            <div class="line" />
            <div class="dot">●</div>
          </div>
          <div class="column pre-close" :style="{left: preCloseLeft + '%'}" v-if="scoreBaseInfo.pre_close > scoreBaseInfo.target_price_low && scoreBaseInfo.pre_close < scoreBaseInfo.target_price_high">
            <div class="dot">●</div>
            <div class="line" />
            <div class="dot-text">昨收${{Number(scoreBaseInfo.pre_close).toFixed(2)}}</div>
          </div>
        </div>
      </div>
      <div class="chart last-block" v-if="suggestDatas.length">
        <p class="header-gap" :class="type">分析师推荐</p>
        <div ref="wrap" class="wrap suggest-wrap" @click="onClickChart" :class="type">
          <div ref="suggestChart" style="width: 100%;height:100%"/>
        </div>
        <div class="items" :class="type">
          <ul class="row between-xs">
            <li v-for="(level,index) in levelName" :key="index"><span :style="{color: level.color}">■</span>{{level.name}}</li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import  { mapState } from 'vuex'
import theme from "./vintage.json"

import {request} from '@/api/request'
import url from 'url'
import { achievement, revenuePie, analysisPie, suggest } from './chartsOptions'

import count from "../../../../filters/count";
// import navigateSchema from '@/constants/navigate-schema'
// import page from '@/mixins/page'
// import bridgeEvent from '@/constants/bridge-event'

const ScoreItems = ['#E63535', '#FF4200', '#FFA700', '#3BDD00', '#1BAA3C']
const TabType = [{
    title: '历史分红',
    event: 'click_historical_dividend.HKstock'
  },{
    title: '拆分合并',
    event: 'click_split_merge_HKstock'
  },{
    title: '回购',
    event: 'click_buy_back_HKstock'
  },]

export default {
  data () {
    return {
      fenhongMore: false,
      chaifenMore: false,
      huigouMore: false,
      symbol: '',
      name: '',
      companyInfo: {},
      tables: [],
      color: [ '#3F76CB', '#f82b52', '#ffb239', '#88808b', '#CB3FB4', '#922BF8', '#FF7139', '#3FB4CB', '#2B2BF8', '#F13ABB', '#B98342' ],
      achieveDatas: [],
      revenueDatas: [],
      suggestDatas: [],
      analysisDatas: {},
      scoreBaseInfo: {}, // 美股目标评级
      institutionTop5: [],
      hkDatas: [],
      insideTop5: [],
      industry: '',
      achieOpt: {},
      revenueOpt: {},
      analysisOpt: {},
      suggestOpt: {},
      showInfo: false,
      scoreObj: {
        analysisScore: 0,
        scoreIndex: 0,
        locationColor: '',
        scoreLeft: -2.6,
        locationLeft: 0
      },
      preCloseLeft: 0,
      averageLeft: 0,
      tabs: ['营业收入', '净利润', '每股收益'],
      top5Title: ['名称', '持股占比', '近期变更'],
      dividentTitle: ['除净日', '派发日', '方案'],
      levelName: [{
        name: '强力买入',
        color: '#E63535',
      }, {
        name: '买入',
        color: '#FF4200',
      },{
        name: '持有',
        color: '#FFA700',
      },{
        name: '业绩不佳',
        color: '#3BDD00',
      },{
        name: '卖出',
        color: '#1BAA3C',
      }],
      positionLegends: [],
      analysisLegends: [{
        name: '机构持股',
        value: 'inst'
      },{
        name: '内部持股',
        value: 'insider'
      },{
        name: '其他',
        value: 'other'
      },{
        name: 'TOP10机构持股',
        value: 'top_10_inst'
      }],
      revenueTabs: [{
        name: '产品',
        value: 'product'
        }, {
        name: '地区',
        value: 'area'
      }],
      itemsName: ['', '同比增长(%)', '实际', '预测'],
      currentIndex: 0,
      revenuecurIdx: 0,
      years: [],
      type: '',
      isHk: 1
    }
  },
  // mixins: [page],
  computed: {
    ...mapState({
      region: state => state.region
    })
  },
  filters: {count},
  async created () {
    this.$echarts = echarts
    let stockInfo = {
      market: this.$route.params.market.toLowerCase(),
      symbol: this.$route.params.code,
      isHK: this.region === 'HK' ? 1 : 0
    }
    document.getElementById('app').style.background = 'white'
    this.$echarts.registerTheme('vintage', theme)
    // this.$showLoading()
    const {symbol, isHK, isHk, name} = stockInfo
    this.symbol = symbol
    this.name = name
    this.isHk = Number(isHK || isHk)
    console.log('isHK', this.isHk)
    this.type = this.$route.query.type
    let tabName = document.getElementsByTagName('html')
    if (this.type === 'dark') tabName[0].style.background = '#1a1e2e'
    this.achieOpt = achievement
    this.achieOpt.xAxis.axisLine = {
      lineStyle: {
        color: this.type === 'dark' ? '#475280' : '#cccccc'
      }
    }
    let data = {}
    if (this.isHk) {
      data = await this.getHkStockInfoLists(this.symbol)
      // this.$hideLoading()
      this.getHkDatas(data)
    } else {
      data = await this.getUsStockInfoLists(this.symbol)
      // this.$hideLoading()
      this.getUsDatas(data)
      this.getData('rtlr')
      this.getRevenueData('product')
      this.getAnalysisData()
      this.getSuggestData()
    }
  },
  methods: {
    getHkStockInfoLists (symbol) {
      const url = request.apis.quote.hkStockInfoList
      return request.get({
        url,
        params: {
          symbol
        }
      })
    },
    getUsStockInfoLists(symbol) {
      const url = request.apis.quote.usStockInfoLists
      return request.get({
        url,
        params: {
          symbol
        }
      })
    },
    getHkDatas (data) {
      this.companyInfo = data.base_info
      this.hkDatas = data
    },
    getUsDatas (data) {
      this.industry = data.sina_gg_data.industry
      this.companyInfo = data.sina_gg_data.summary
      this.achieveDatas = data.sina_gg_data.chart
      this.revenueDatas = data.sina_cj_data.revenue
      this.suggestDatas = data.sina_cj_grade.recommend_org.reverse()
      this.analysisDatas = data.sina_cj_data.analysis
      this.scoreBaseInfo = data.sina_cj_grade.baseinfo
      const currencycode = this.achieveDatas[0].annual ? this.achieveDatas[0].annual.currencycode : '--'
      this.itemsName[0] = `营业收入(${currencycode})`
      this.institutionTop5 = data.sina_cj_data.hold.inst
      this.insideTop5 = data.sina_cj_data.hold.stake
      const {pre_close, target_price, mark, target_price_high, target_price_low} = this.scoreBaseInfo
      if (mark.value) {
        this.scoreObj.analysisScore = Number(mark).toFixed(2)
        const _score = Number((this.scoreObj.analysisScore - 1).toFixed(2))
        this.scoreObj.scoreIndex = Math.ceil(_score / 0.4) -1
        this.scoreObj.locationColor = ScoreItems[this.scoreObj.scoreIndex]
        if (_score <= 0.06) {
          this.scoreObj.locationLeft = ((_score * 100 - 6) * 6.2).toFixed(1)
        } else if(_score >= 1.81) {
          this.scoreObj.locationLeft = (( _score - 1.81) * 100 * 2).toFixed(1)
          this.scoreObj.scoreLeft = 85.3
        } else {
          this.scoreObj.scoreLeft = (_score / 2 * 100 - 5).toFixed(2)
        }
        console.log(this.scoreObj)
      }
      if (!pre_close || !target_price) return
      const val = target_price_high - target_price_low
      this.preCloseLeft = ((pre_close - target_price_low) / val * 100).toFixed(2)
      this.averageLeft = ((target_price - target_price_low) / val * 100).toFixed(2)
    },
    onSwitch (e) {
      e === 'open' ? this.showInfo = true : this.showInfo = false
    },
    onClickTab (index) {
      this.currentIndex = index
      if (index === 0) {
        this.getData('rtlr')
      } else if (index === 1) {
        this.getData('nibx')
      } else {
        this.getData('vdes')
      }
    },
    onClickRevenueTab (index, tab) {
      this.revenuecurIdx = index
      this.getRevenueData(tab)
    },
    getRevenueData (tab) {
      let chart = this.$echarts.init(this.$refs.revenueChart, 'vintage')
      this.positionLegends = []
      this.revenueOpt = revenuePie
      this.revenueOpt.series[0].data = []
      if (!this.revenueDatas[tab]) return
      this.revenueDatas[tab].forEach(item => {
      this.revenueOpt.series[0].data.push({
        name: item.label,
        value: item.sales
      })
      })
      this.revenueOpt.title.text = (this.revenueDatas.area[0].sales / 100000000).toFixed(2) + '亿'
      this.revenueDatas[tab].forEach(item => {
        this.positionLegends.push({
          name: item.label,
          value: Math.abs(Number(item.sales) / 100000000) > 1 ? (Number(item.sales) / 100000000).toFixed(2) + '亿' : (Number(item.sales) / 10000).toFixed(2) + '万'
        })
      })
      chart.setOption(this.revenueOpt)
    },
    getAnalysisData () {
      if (!this.analysisDatas.hasOwnProperty('inst_and_insider_total')) return
      let chart = this.$echarts.init(this.$refs.analysisChart, 'vintage')
      this.$echarts.registerTheme('vintage', theme)
      this.analysisOpt = analysisPie
      this.analysisOpt.series[0].data = [{
        name: '机构持股',
        value: this.analysisDatas.inst
      }, {
        name: '内部持股',
        value: this.analysisDatas.insider
      },{
        name: 'TOP10机构持股',
        value: this.analysisDatas.other
      }]
      this.analysisOpt.series[1].data = [{
        name: '其他',
        value: this.analysisDatas.top_10_inst
      }, {
        name: '',
        value: 100 - this.analysisDatas.top_10_inst,
        itemStyle: {
          color: '#fff'
        }
      }]
      this.analysisOpt.title.text = (this.analysisDatas.shares / 100000000).toFixed(2) + '亿股'
      chart.setOption(this.analysisOpt)
      console.log('this.analysisOpt', this.analysisOpt)
    },
    getSuggestData () {
      if (!this.suggestDatas.length) return
      this.suggestOpt = suggest
      this.suggestDatas.forEach(item => {
        this.suggestOpt.xAxis.data.push(item.date_month.substr(0, 7).replace('-', '/'))
        this.suggestOpt.series[4].data.push({
          value: item.over,
          label: {
            show: item.over.value > (item.total / 4)
          }
        })
        this.suggestOpt.series[3].data.push({
          value: item.buy,
          label: {
            show: item.buy > (item.total / 4)
          }
        })
        this.suggestOpt.series[2].data.push({
          value: item.hold,
          label: {
            show: item.hold > (item.total / 4)
          }
        })
        this.suggestOpt.series[1].data.push({
          value: item.under,
          label: {
            show: item.under > (item.total / 4)
          }
        })
        this.suggestOpt.series[0].data.push({
          value: item.sell,
          label: {
            show: item.sell > (item.total / 4)
          }
        })
      this.suggestOpt.series[5].data.push(item.total)
      })
      this.$nextTick(() => {
        let chart = this.$echarts.init(this.$refs.suggestChart)
        chart.setOption(this.suggestOpt)
      })
      console.log('this.suggestOpt', this.suggestOpt)
    },
    getData (value) {
      let chart = this.$echarts.init(this.$refs.achieChart)
      const revenue = this.achieveDatas.map(item => {
        return !item.annual.rtlr ? Number.parseFloat((item.interim[0][value] * 100).toFixed(1)) : Number.parseFloat((item.annual[value] * 100).toFixed(1))
      }).slice(-5)
      const years = this.achieveDatas.map(item => {
        return `${item.fiscalyear}年`
      })

      const rate = revenue.reduce((acc, currentValue, currentIndex, array) => {
        const nextValue = array[currentIndex + 1]
        if (nextValue) {
          acc.push(Number.parseFloat((((nextValue - currentValue) / Math.abs(currentValue)) * 100).toFixed(1)))
        }
        return acc
      }, [])
      const _revenue = revenue.length > 4 ? revenue.slice(-4) : revenue
      const _rate = rate.length === 4 ? rate.slice(0, 3) : [null, ...(rate.slice(0, rate.length - 1))]

      this.years = years.length > 4 ? years.slice(-4) : years
      this.achieOpt.xAxis.data = this.years
      this.achieOpt.series[0].data = _revenue
      this.achieOpt.series[1].data = _rate
      chart.setOption(this.achieOpt)
    },
    onClickChart () {
      const showLabel = this.achieOpt.series[1].label
      showLabel.show === false ? showLabel.show = true : showLabel.show = false
    }
    // goTo (type) {
    //   const title = TabType[type - 1].title

    //   const query = {
    //     title,
    //     symbol: this.symbol,
    //     type,
    //     market: this.market,
    //     name: this.name
    //   }

    //   const schema = navigateSchema.web

    //   const data = {
    //     symbol: this.symbol,
    //     market: this.market,
    //     url: `${window.location.origin}${window.location.pathname}#/gmg-brief-detail?symbol=${this.symbol}&type=${type}`,
    //     title: title,
    //     name: this.name
    //   }
    //   this.$sa.track(TabType[type-1].event)
    //   // 因 IOS JS Bridge兼容问题做特殊处理
    //   if (this.inApp) {
    //     window.YTXBridge
    //     ? this.fireEvent(bridgeEvent.navigate, { schema, data })
    //     : window.location.href = `${window.location.origin}${window.location.pathname}${url.format({ query: { title } })}#/gmg-brief-detail?symbol=${this.symbol}&type=${type}`
    //   } else {
    //     this.$router.push(`/gmg-brief-detail?symbol=${this.symbol}&type=${type}`)
    //   }
    // }
  }
}
</script>

<style lang="stylus" scoped>
.dropped
  color: #1BAA3C !important
.rise
  color: #E63535 !important
.zero
  color: #999 !important

.down-btn
  display flex
  color #409afb
  justify-content: center
  align-items baseline
  position relative
  font-size 12px
  .downrect-ico
    background url('../../../../assets/downrect.png')
    width 11px
    height 11px
    display block
    background-size contain
    background-repeat no-repeat
    position absolute
    left 190px
    top 6px
  .uprect-ico
    background url('../../../../assets/downrect.png')
    width 11px
    height 11px
    display block
    background-size contain
    background-repeat no-repeat
    transform: rotate(180deg)
    position absolute
    left 190px
    bottom 6px
.row {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.between-xs {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.top-xs {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}
.stock-info {
  width: 100%;
  font-size: .15rem;
  color #262D40
  background: #f8f9fe
  // padding-bottom .5rem
}

.stock-info.dark {
  background: #1a1e2e;
  color: #999999;
}

.header-gap.dark {
  color: #cccccc;
  border-left: 2px solid #ff8080
}

.co-info, .main-shareholder, .history-divident, .chart, .top5,.goal-level,.goal-price {
  padding: .09rem .15rem
  background #fff
  margin-bottom .06rem
}

.chart, .top5, .goal-level,.goal-price
  padding: .18rem .15rem

.last-block
  margin-bottom 0
  padding-bottom .4rem

.co-info.dark, .chart.dark {
  border-bottom: .5px solid #12141f;
}

.header-gap {
  padding-bottom: .1rem;
  width: 100%;
  font-size: .16rem;
  color: #333;
  font-weight: 500;
}

.hk-header
  border-bottom 1px solid #EDEFF3

.arrow-right
  width .06rem
  height .12rem
.content > p, .content > div {
  padding: .09rem .06rem + 0.02rem 0;
  span {
    display: inline-block;
  }
}

.text {
  width: 2.6rem;
  text-align: left;
}

.name, .text {
  color: #333;
  font-size: 15px;
}

.text.dark, .name.dark {
  color: #999
}

.info-text {
  width: 2.6rem;
  .hide {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2
    overflow: hidden;
  }
}

.switch {
  color: #4d97ff;
  padding-top: .06rem;
}

.switch.dark {
  color: #80b5ff
}


.open {
  font-size: 0.12rem;
}
.close {
  font-size: 0.12rem;
}

.open:after,.close:after {
  content: '\00a0\00a0';
  margin-left: .06rem;
}
.switch
  .open:after{
    width: 0.11rem;
    height: 0.11rem;
    display: inline-block;
    background-size: contain;
    background: url("../../../../assets/downrect.png") no-repeat center / contain;
  }

.switch.dark
  .open:after{
    background: url("../../../../assets/icons/icon-down-night.png") no-repeat center / contain;
  }

.switch
  .close:after {
    width: 0.11rem;
    height: 0.11rem;
    display: inline-block;
    background-size: contain;
    background: url("../../../../assets/downrect.png") no-repeat center / contain;
    transform: rotate(180deg);
  }

.switch.dark
  .close:after {
    background: url("../../../../assets/icons/icon-up-night.png") no-repeat center / contain;
  }

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-top: .18rem;
  line-height: 2.5;
  thead {
    background: rgba(255,51,51,0.1);
    font-weight: normal;
    color: #666;
  }
  tbody {
    text-align: center;
    background: #fafafa;
    .plural {
      background: #f2f2f2;
    }
  }
}

table.dark
  thead {
    background: #242a40;
    color: #cccccc;
  }
  tbody {
    background: #1a1e2e;
    color: #999;
    .plural {
      background: #1d2133;
    }
  }

.nav {
  width: 100%;
  padding: .18rem 0
  .tabs {
    border-radius: 2px;
    border: .5px solid #9DA1A9;
    .tab {
      color #091428
      text-align: center;
      line-height: 2.1;
    }
  }
}

.border-l
  border-right .5px solid #9DA1A9

.border-r
  border-left .5px solid #9DA1A9

.nav.dark {
  border: none;
  background: #242a40;
  color: #999;
  .active {
    background: #475280;
    color: #cccccc;
  }
}

.active {
  border-radius: 2px;
  background: #007AFF
  color: white!important
}

.wrap {
  border-radius: 0.25em;
  overflow: hidden;
  width: 100%;
  height: 2.75rem;
}

.wrap.dark {
  border: .5px solid #475280;
}

.items > ul {
  color #091428
  margin: .09rem;
  font-size .12rem
}

.item-0:before, .item-1:before, .item-2:before, .item-3:before {
  content: '\00a0\00a0\00a0';
  margin-right: .03rem;
}

.items{
  .item-0:before {
    background: url("../../../../assets/icons/statistics.png") no-repeat center / contain;
  }

  .item-1:before {
    background: url("../../../../assets/icons/growth.png") no-repeat center / contain;
  }

  .item-2:before {
    content: '\00a0\00a0'
    background: url("../../../../assets/icons/rectangle-filled.png") no-repeat center / contain;
  }

  .item-3:before {
    content: '\00a0\00a0'
    background: url("../../../../assets/icons/rectangle-dotted.png") no-repeat center / contain;
  }
}

.items.dark {
  .item-0:before {
    background: url("../../../../assets/icons/statistics-night.png") no-repeat center / contain;
  }

  .item-1:before {
    background: url("../../../../assets/icons/growth-night.png") no-repeat center / contain;
  }

  .item-2:before {
    background: url("../../../../assets/icons/rectangle-filled-night.png") no-repeat center / contain;
  }

  .item-3:before {
    background: url("../../../../assets/icons/rectangle-dotted-night.png") no-repeat center / contain;
  }
}

.echarts {
  width: 100%;
  min-width: 0;
  height: 100%
  // height: 65vw;
  // position: relative;
  // left: -0.8rem;
  // top: -1rem;
}

.position-wrap
  width 100%
  height: 180px
  .echarts
    width: 50%
    height 100%

.revenue-wrap
  .echarts
    width: 50%
    height: 200px

.analysis-lists
  font-size .12rem
  color #262D40
  line-height 2

.content-wrap
  width 100%
  .title
    font-size .13rem
    color #999
    padding .1rem 0

.position-legend-wrap
  height 100%
  color #61697E
  font-size .12rem

.position-legend,.analysis-legend
  padding .2rem 0
  min-height 100%
  height max-content
  .legend-item
    margin-bottom .05rem
    &:last-child
      margin-bottom 0
    span
      display inline-block
    .legend-item-name
      max-width .9rem
      text-overflow: -o-ellipsis-lastline
      overflow: hidden
      text-overflow: ellipsis
      display: -webkit-box
      -webkit-line-clamp: 2
      -webkit-box-orient: vertical
    .legend-item-value
      color #262D40

// .position-legend
//   padding 0

.inst_and_insider_total
  color #7A8499

.square
  font-size .15rem
  margin-right .05rem

.square0
  color #2677F1
.square1
  color #F82B52
.square2
  color #FFB239
.square3
  color #88808B

.top5-content,.hk-data-ul
  padding .04rem 0
  width 100%
  font-size .15rem
  color #262D40

.title0,.align-l-50
  width 50%
  text-align left
.title1,.align-r-20
  width 20%
  text-align right
.title2,.align-r-30
  width 30%
  text-align right

.top5-date
  font-size .12rem
  color #7A8499

.stock_holder
  font-size .15rem
  padding-bottom .025rem

.stock_holder:last-child
  padding-bottom 0

.divident-title0,.divident-title1,.align-l-30
  width 30%
  text-align left
.divident-title2,.align-r-40
  width 40%
  text-align right

.limit-score
  font-size .12rem
  margin-top .25rem

.line-wrap
  margin .02rem .06rem
  padding .04rem 0
  height .27rem
  border-left 1px solid #E63535
  border-right 1px solid #1BAA3C
  position relative

.score-wrap
  font-size .12rem
  top: -0.31rem
  position absolute
  width max-content
  .score
    width 100%
  .location-icon
    margin-top .02rem
    width .12rem
    height .16rem
    position relative

.location0
  background url("../../../../assets/icons/location1.png") no-repeat center / contain

.location1
  background url("../../../../assets/icons/location2.png") no-repeat center / contain

.location2
  background url("../../../../assets/icons/location3.png") no-repeat center / contain

.location3
  background url("../../../../assets/icons/location4.png") no-repeat center / contain

.location4
  background url("../../../../assets/icons/location5.png") no-repeat center / contain

.linear-line-wrap
  height 100%
  .linear-line
    height 100%
    border-radius 1px
    background linear-gradient(to right, #E63535,#FF4200,#FFA700,#3BDD00,#1BAA3C)

.level-name
  padding 0 .05rem
  font-size .13rem
  color #7A8399

.suggest-wrap
  height 2.75rem

.axes-wrap
  position relative
  height 0.75rem
  color #007AFF
  margin-top .4rem
  .dot-text
    color #7A8399
    font-size .13rem
  .dot
    font-size .11rem
    line-height 1
  .axes
    margin .05rem
    height .04rem
    width 98%
    border-top .04rem solid #007AFF
  .low,.high,.average,.pre-close
    position absolute
  .low
    left 0
    top -.025rem
    align-items flex-start
    .line
      width 1px
      height .15rem
      border-left 1px solid #007AFF
      position relative
      top -.075rem
      left .05rem
  .pre-close
    top -.025rem
    align-items center
    .line
      width 1px
      height .35rem
      border-left 1px solid #007AFF
      position relative
      top -.075rem
  .high
    right 0
    top -.025rem
    align-items flex-end
    .line
      width 1px
      height .15rem
      border-left 1px solid #007AFF
      position relative
      top -.075rem
      right .05rem
  .average
    top -.365rem
    align-items center
    .dot-text
      color #007AFF
    .line
      width 1px
      height .15rem
      border-left 1px solid #007AFF
      position relative
      bottom -.075rem
      // right .1rem
</style>
